import DoneIcon from '@mui/icons-material/Done';
import { Box } from '@mui/material';
import { FilterOptionType, StyleOptions } from '@sm-dashboard/types';
import { getSourceTypeForegroundColor, sourceType } from '../grid/renderCell';

export const statusArr: FilterOptionType[] = [
  { name: 'פתוח', value: 'true', color: 'secondary' },
  { name: 'סגור', value: 'false', color: 'success', icon: <DoneIcon /> }
];

const LEADS_SOURCE_FILTER_KEYS = new Set(['personal', 'paid', 'organic']);

export const sourceOptions: FilterOptionType[] = Object.entries(sourceType).map(([key, value]) => ({
  value: key,
  label: value.label,
  icon: (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiSvgIcon-root': { fontSize: '1rem' }
      }}
      width={22}
      height={22}
      color={getSourceTypeForegroundColor(value.bgcolor || 'info.main')}
      bgcolor={value.bgcolor || 'info.main'}
      borderRadius="50px"
    >
      {value.icon}
    </Box>
  ),
  color: value.bgcolor as StyleOptions,
  isNotChip: true
}));

export const leadsSourceOptions: FilterOptionType[] = sourceOptions.filter(opt =>
  LEADS_SOURCE_FILTER_KEYS.has(String(opt.value))
);
